'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Heart;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Heart(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      className: 'icon-svg-heart ' + className,
      width: width,
      height: height,
      focusable: 'false',
      'aria-hidden': true,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.552 2.833a3.618 3.618 0 0 1 1.159 1.714c.215.679.247 1.361.094 2.049a3.547 3.547 0 0 1-.984 1.78L8.62 13.732A.855.855 0 0 1 8 14a.855.855 0 0 1-.62-.268L2.18 8.403a3.703 3.703 0 0 1-.984-1.807 3.875 3.875 0 0 1 .094-2.049 3.618 3.618 0 0 1 1.16-1.714 3.42 3.42 0 0 1 1.643-.776 3.652 3.652 0 0 1 1.806.134 3.823 3.823 0 0 1 1.563.99L8 3.717l.539-.536c.45-.464.97-.794 1.563-.99a3.652 3.652 0 0 1 1.806-.134 3.42 3.42 0 0 1 1.644.776z' })
  );
}

Heart.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Heart/Heart.js
// module id = 245
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16